const AppVersion = {
  version: "3.3.57",
  build: "3.3"
};

export default AppVersion;
